module.exports = ".main {\n  display: flex;\n  flex-direction: row;\n}\n\n.bottomButton {\n  width: 8%;\n}\n\n.bottomButton img {\n  width: 100%;\n}\n"